import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';


export enum EstadoConexao {
  OCIOSO = 'ocioso',
  DESCONECTADO = 'desconectado',
  CONECTANDO = 'conectando...',
  CONECTADO = 'contectado'
}


export class SseNotificacao {
  public static readonly instance: SseNotificacao = new SseNotificacao();
  private eventSource? : EventSource;
  /**
   * Tempo para retry caso a conexão caia
   */
  private RETRY = 15000;

  private obterToken: () => any = () => undefined;

  private onOpenFunction?: () => void;
  private onErrorFunction?: (ev: Event) => void;
  private onMessageFunction?: (ev: MessageEvent) => any;

  get inicializado() {
    return this.estadoConexao !== EstadoConexao.OCIOSO;
  }

  inicializar(obterTokenFunction: () => any) {
    if (this.inicializado) {
      throw new Error("SseNotificacao já inicializado");
    }

    this.obterToken = obterTokenFunction;

    this.conectar();
  }

  private conectar() {
    const EventSource = NativeEventSource || EventSourcePolyfill;
    
    const token = this.obterToken();
    const url = `${process.env.REACT_APP_NOTIFICACAO_HOST}/lista/acompanhar?access_token=${token}`;

    this.eventSource = new EventSource(url);
    this.eventSource!!.onopen = () => this.onOpenInterno();
    this.eventSource!!.onerror = (e) => this.onErrorInterno(e);
    this.eventSource!!.onmessage = (e) => this.onMessageInterno(e);
  }

  public getEventSource(): EventSource|undefined {
    return this.eventSource;
  }

  get estadoConexao(): EstadoConexao {
    if (this.eventSource === undefined) {
      return EstadoConexao.OCIOSO;
    } else if (this.eventSource.readyState === EventSource.CLOSED) {
      return EstadoConexao.DESCONECTADO;
    } else if (this.eventSource.readyState === EventSource.CONNECTING) {
      return EstadoConexao.CONECTANDO;
    } else {
      return EstadoConexao.CONECTADO;
    }
  }

  private onOpenInterno() {
    if (this.onOpenFunction !== undefined) {
      this.onOpenFunction();
    }
  }

  private onErrorInterno(ev: Event) {
    if (this.estadoConexao === EstadoConexao.DESCONECTADO) {
      this.eventSource?.close();

      window.setTimeout(() => this.conectar(), this.RETRY);
    }

    if (this.onErrorFunction !== undefined) {
      this.onErrorFunction(ev);
    }

    // https://github.com/Yaffle/EventSource/issues/76#issuecomment-633334313
    // ev.preventDefault();
  }

  private onMessageInterno(ev: MessageEvent) {
    if (ev.data === "CONECTADO") {
      return;
    }

    if (this.onMessageFunction !== undefined) {
      this.onMessageFunction(ev);
    }
  }

  set onopen(onOpen: () => void) {
    this.onOpenFunction = onOpen;
  }

  set onerror(onError: (ev: Event) => void) {
    this.onErrorFunction = onError;
  }

  set onmessage(onMessage: (ev: MessageEvent) => any) {
    this.onMessageFunction = onMessage;
  }
}
